console.log("AAAASK")

import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [
    "content",
    "text",
    "footer",
    "submitButton",
    "toDisable",
    "wrapper",
    "userMessages",
    "messageAfterSend",
    "form",
    "quizQuestionInput"
  ]

  static values = {
    formIsDirty: Boolean
  }

  connect() {
    console.log("ASK CONTROLLER")
    let controller = this

    this.hideForm()

    window.addEventListener("beforeunload", function (event) {
      if (controller.formIsDirtyValue) {
        event.preventDefault()
        return event.returnValue = ''
      }
    });    

    this.checkDirtyness()
  }

  hideForm() {
    this.toDisableTargets.forEach((el) => {
      el.disabled = true
    })
  }

  showForm() {
    this.toDisableTargets.forEach((el) => {
      el.disabled = false
    })
  }

  checkDirtyness() {
    let isClean = this.textTarget.value == ''

    if (isClean) {
      this.submitButtonTarget.classList.add('disabled')
    } else {
      this.submitButtonTarget.classList.remove('disabled')
    }

    this.submitButtonTarget.disabled = isClean
    this.formIsDirtyValue = !isClean
  }

  reset() {
    this.textTarget.value = ""
    this.contentTarget.innerHTML = ""
    this.footerTarget.classList.remove('disabled')
    this.toDisableTargets.forEach(el => el.disabled = false)
    this.checkDirtyness()
  }

  submitForm(e) {
    this.formIsDirtyValue = false

    // FIXME: Do this by talking to the controller
    if (this.hasQuizQuestionInputTarget && document.querySelector('.quiz')) {
      this.quizQuestionInputTarget.value = document.querySelector('.quiz').getAttribute("data-question-id-value")
      console.log("QQI", this.quizQuestionInputTarget.value)
    }

    // this.toDisableTargets.forEach((el) => {
    //   el.disabled = true
    //   el.classList.add("disabled")
    // })

    this.messageAfterSendTargets.forEach((el) => {
      el.classList.remove("hidden")
    })

    return true
  }

}